/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let NuAcUpdatesUrl = root.nuAcUpdatesUrl.link;
let BlockUserUrl = root.blockUserUrl.link;
let UnBlockUserUrl = root.unblockUserUrl.link;
let memberUsersUrl = root.acOrgUserUrl.link;
let userDetailsURL = root.userDetailsUrl.link;
let deactivatedUsersListsURL = root.deactivatedUsersListsUrl.link;
let authUserAgreementURL = root.authUserAgreementUrl.link;
let memberSearchKeyURL = root.memberSearchKeyUrl.link;
let guestAllUsersListURL = root.guestAllUsersListUrl.link;
let allUserCountApiURL = root.allUserCountApiUrl.link;
let isConditionalListOfAllUsersApiURL = root.isConditionalListOfAllUsersApiUrl.link;
let getProfilePhotoOfCurrentApiUrl = root.getProfilePhotoOfCurrentApiUrl.link;
let roomCreateIdforGlobalSocketApi = root.roomCreateIdforGlobalSocketApi.link;
let uploadUsrCVApiUrl = root.uploadUsrCVApiUrl.link;
let getCVbyUserIdApiUrl = root.getCVbyUserIdApiUrl.link;
let deleteCvFromSelfId = root.deleteCvFromSelfId.link;


export default {
  state: {
    getNuAcUpdatesListState:{},
    createdBlockState:{},
    getBlockState:{},
    memberAllUsersState:{},
    getMemberUserDetailsState:{},
    getDeactivatedAllUserListState:{},
    getGuestUserListState:{},
    getAllUserCountState:{},
    isConditionalListOfAllUsersState:{},
    getProfilePhotoOfCurrentState:{}
  },
  mutations: {
    getGuestUserListMut(state, value) {
      Vue.set(state, 'getGuestUserListState', value);
    },
    getNuAcUpdatesListMut(state, value) {
      Vue.set(state, 'getNuAcUpdatesListState', value);
    },
    createdBlockUserMut(state,value){
      Vue.set(state,'createdBlockState',value)
    },
    getBlockUserMut(state,value){
      Vue.set(state,'getBlockState',value)
    },
    memberAllUsersMuatation(state,value){
      Vue.set(state,'memberAllUsersState',value)
    },
    getMemberUserDetailsMuatation(state,value){
      Vue.set(state,'getMemberUserDetailsState',value)
    },
    getDeactivatedAllUserListMuatation(state,value){
      Vue.set(state,'getDeactivatedAllUserListState',value)
    },
    getAllUserCountMut(state,value){
      Vue.set(state,'getAllUserCountState',value)
    },
    isConditionalListOfAllUsersMut(state,value){
      Vue.set(state,'isConditionalListOfAllUsersState',value)
    },
    getProfilePhotoOfCurrentMut(state,value){
      Vue.set(state,'getProfilePhotoOfCurrentState',value)
    },
  },
  actions: {
    // Delete CV by User Id Action
    deleteCVbyUserIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(deleteCvFromSelfId).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get CV by User Id Action
    getCVbyUserIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getCVbyUserIdApiUrl + "?user_id=" + payload.id).then(res => {
              context.commit('getNuAcUpdatesListMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Upload Usr CV Action
    uploadUsrCVAction(context,payload){
      return new Promise ((resolve, reject) => {
         axios.post(uploadUsrCVApiUrl, payload).then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // room Create Id for Global Socket Function
    roomCreateIdforGlobalSocketMethod(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(roomCreateIdforGlobalSocketApi).then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Al User List Of Conditional Function
    getProfilePhotoOfCurrentFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(getProfilePhotoOfCurrentApiUrl, payload).then((res)=>{
          context.commit('getProfilePhotoOfCurrentMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Al User List Of Conditional Function
    isConditionalListOfAllUsersFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(isConditionalListOfAllUsersApiURL, payload).then((res)=>{
          context.commit('isConditionalListOfAllUsersMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Guest User List Function
    getGuestUserListFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(guestAllUsersListURL, payload).then((res)=>{
          context.commit('getGuestUserListMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Member User Search Function
    memberUserSearchFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.post(memberSearchKeyURL, payload).then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Auth User Agrrement Function
    authUserAgreementFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.post(authUserAgreementURL, payload).then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Get Su Ac Updates List
    getNuAcUpdatesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(NuAcUpdatesUrl + "?page_size=14").then(res => {
              context.commit('getNuAcUpdatesListMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    createBlockUserFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.post(BlockUserUrl, payload).then((res)=>{
          context.commit('createdBlockUserMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    getBlockUserFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(BlockUserUrl).then((res)=>{
          context.commit('getBlockUserMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    unBlockUserFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.delete(UnBlockUserUrl + payload.id + '/').then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    memberAllUsersListFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(memberUsersUrl).then((res)=>{
          context.commit('memberAllUsersMuatation', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    getMemberUserDetailsFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(userDetailsURL + payload.id + '/').then((res)=>{
          context.commit('getMemberUserDetailsMuatation', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    getDeactivatedAllUserListsFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(deactivatedUsersListsURL).then((res)=>{
          context.commit('getDeactivatedAllUserListMuatation', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    getAllUserCountFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.get(allUserCountApiURL).then((res)=>{
          context.commit('getAllUserCountMut', res.data);
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
  },
  getters: {
    getNuAcUpdatesListGetters: state => state.getNuAcUpdatesListState,
    createdBlockGetters:state => state.createdBlockState,
    getBlockGetters:state => state.getBlockState,
    memberAllUsersGetters:state => state.memberAllUsersState,
    getMemberUserDetailsGetters: state => state.getMemberUserDetailsState,
    getDeactivatedAllUserListGetters: state => state.getDeactivatedAllUserListState,
    getGuestUserListGetters: state => state.getGuestUserListState,
    getAllUserCountGetters: state => state.getAllUserCountState,
    isConditionalListOfAllUsersGetters: state => state.isConditionalListOfAllUsersState,
    getProfilePhotoOfCurrentGetters: state => state.getProfilePhotoOfCurrentState
  }
}